const initialState = {
    user: null,
};

export default function auth(state = initialState, action) {
    switch (action.type) {
        case 'SET_AUTH':
            return action.value;
        case 'SET_AUTH_USER':
            return {
                ...state,
                user: action.value
            };
        default:
            return state;
    }
}
